@use '../../styling/colors.scss' as *;

.ScrollableTable {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: 100%;
  border: 1px solid $theme-color-borders;
  border-radius: 6px 6px 0 0;
  background-color: $theme-color-sub-background;

  [aria-hidden='true']>table {
    display: block;
  }

  .Header {
    background-color: $theme-color-table-header-background;
    border-radius: 6px 6px 0 0;
    border-bottom: 1px solid $theme-color-borders;

    th:hover {
      background-color: $theme-color-table-hover;
    }
  }

  .ScrollableContainer {
    flex: 1;
    overflow: hidden auto;
    display: flex;
    flex-direction: column;

    table {
      margin-top: -1px;
      background: transparent;
    }

    .buttonWrapper {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      align-self: center;
      padding: 1em 0;
    }

    thead {
      opacity: 0;
      border: 0;

      tr,
      th {
        border: 0;
      }
    }
  }
}
